export const deleteBlankPropertiesFromObject = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (Array.isArray(obj[key]) && obj[key].length === 0) {
      delete obj[key]
    }
    if (obj[key] === '') {
      delete obj[key]
    }
  })
  return obj
}

export const arrayWrap = item => (Array.isArray(item) ? item : [item])

export const deepCopy = item => JSON.parse(JSON.stringify(item))

export const isEmptyObject = obj =>
  obj && Object.keys(obj).length === 0 && obj.constructor === Object

export const smoothScroll = (targetSelector) => {
  const top = targetSelector
    ? document.querySelector(targetSelector).offsetTop
    : 0
  window.scroll({
    top,
    left: 0,
    behavior: 'smooth'
  })
}

export const arrayUniqueBy = (array, uniqueBy) =>
  array.filter(
    (e, i) => array.findIndex(a => a[uniqueBy] === e[uniqueBy]) === i
  )
export const arrayUnique = array => [...new Set(array)]

// Function to convert array values to comma-separated strings
export const convertArrayValuesToString = (inputObj) => {
  const result = {}

  for (const key in inputObj) {
    if (Array.isArray(inputObj[key])) {
      result[key] = inputObj[key].join(',')
    } else {
      result[key] = inputObj[key]
    }
  }

  return result
}
